import { render, staticRenderFns } from "./AdminProductSelectorsEditScreen.vue?vue&type=template&id=bef78aba&scoped=true&"
import script from "./AdminProductSelectorsEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductSelectorsEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef78aba",
  null
  
)

export default component.exports